module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw PushDown-hbg Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter4"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block9"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p334"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("A")]), _vm._v("sh trudged across the field separating his land from his nearest neighbor’s. He could have driven his truck, but he figured the walk over and back would help him do some heavy thinking.\n         ")]), _c('p', {
    attrs: {
      "id": "p335"
    }
  }, [_vm._v("Old Fred Covington had been making noises about wanting Ash’s ranch ever since he’d learned that Ash’s bid at the county auction had been higher than his. It had been an uphill battle, but Ash had finally managed to break through the old man’s icy wall until they were now, if not friendly, at least neighborly.")]), _c('p', {
    attrs: {
      "id": "p336"
    }
  }, [_vm._v("It hadn’t been easy for Ash to request this meeting with Fred Covington and openly admit to his financial problems with the bank.")]), _c('p', {
    attrs: {
      "id": "p337"
    }
  }, [_vm._v("“Ash.” Fred stuck out his hand.")]), _c('p', {
    attrs: {
      "id": "p338"
    }
  }, [_vm._v("“Fred. Thanks for agreeing to see me.”")]), _c('p', {
    attrs: {
      "id": "p339"
    }
  }, [_vm._v("The old man glanced up at the layers of clouds rolling in from the north. “Afraid I can’t give you much time. Got to see to my herd. What’s this about?”")]), _c('p', {
    attrs: {
      "id": "p340"
    }
  }, [_vm._v("As briefly as possible Ash told him about his meeting with the banker, and the disastrous outcome.")]), _c('p', {
    attrs: {
      "id": "p341"
    }
  }, [_vm._v("His words were met with narrowed eyes and a tightening of the lips, a sure indication that the stern-faced neighbor was about to gloat and offer him a lowball figure to take the land and buildings off his hands.")]), _c('p', {
    attrs: {
      "id": "p342"
    }
  }, [_vm._v("In truth, Ash was prepared to accept whatever offer was made. He’d run out of options.")]), _c('p', {
    attrs: {
      "id": "p343"
    }
  }, [_vm._v("The old man spat a wad of tobacco. “I could have told you what you’d get from the Colliers. Father and son are both more concerned about squeezing every drop of blood they can from the hardworking ranchers around here than they are with lending a hand when it’s needed.” Fred pursed his lips, considering. “How much do you need to get that irrigation system repaired?”")]), _c('p', {
    attrs: {
      "id": "p344"
    }
  }, [_vm._v("Ash shrugged, trying his best to hold onto his dignity. “They’re asking thirty grand.”")]), _c('p', {
    attrs: {
      "id": "p345"
    }
  }, [_vm._v("“Thirty.” Fred shoved back his hat to scratch his head. “Then I figure they’ll probably take ten up front, and ask for the rest in payments.”")]), _c('p', {
    attrs: {
      "id": "p346"
    }
  }, [_vm._v("“Yes, sir. That’s what I’m figuring, too.”")]), _c('p', {
    attrs: {
      "id": "p347"
    }
  }, [_vm._v("“And your taxes?”")]), _c('p', {
    attrs: {
      "id": "p348"
    }
  }, [_vm._v("“I thought I’d be able to cover them, but everything started piling up.”")]), _c('p', {
    attrs: {
      "id": "p349"
    }
  }, [_vm._v("“Yeah. That’s a rancher’s reality.” The old man stared off into space before turning to meet Ash’s eyes. “All right. Come on up to the house. I’ll write a check for the irrigation company and the bank.” He started away.")]), _c('p', {
    attrs: {
      "id": "p350"
    }
  }, [_vm._v("Ash was choking on the lump in his throat. “You…” He swallowed and tried again. “You’ll have yourself some fine land for the price of taxes and an irrigation system.”")]), _c('p', {
    attrs: {
      "id": "p351"
    }
  }, [_vm._v("Fred stopped dead in his tracks and turned. “Is that what you think? That I’m hoping to take over your place?”")]), _c('p', {
    attrs: {
      "id": "p352"
    }
  }, [_vm._v("“Aren’t you?”")]), _c('p', {
    attrs: {
      "id": "p353"
    }
  }, [_vm._v("Fred Covington gave him a long, assessing look. “Since you took over this place, I’ve been talking with some other ranchers in the area. They tell me you were one of their best workers, and you’ve been saving every dollar you earned to buy this ranch. That right?”")]), _c('p', {
    attrs: {
      "id": "p354"
    }
  }, [_vm._v("“Yes, sir.”")]), _c('p', {
    attrs: {
      "id": "p355"
    }
  }, [_vm._v("“I figured you’d just asked your daddy to buy you a place of your own, but I’ve heard you haven’t taken one red cent from your pa.” When Ash held his silence he said, “This land was built by men like my granddaddy. I like a man who lives by a cowboy’s rugged code of independence. That’s why I’m offering you a loan so you can hold on to what you’ve earned by the sweat of your brow.”")]), _c('p', {
    attrs: {
      "id": "p356"
    }
  }, [_vm._v("As his words sank in, Ash’s eyes rounded. “I don’t know when I’ll be able to pay you back.”")]), _c('p', {
    attrs: {
      "id": "p357"
    }
  }, [_vm._v("Fred’s lips curved. “I figure you’re good for the money. And if you don’t pay me back, son, I know where you live.”")]), _c('p', {
    attrs: {
      "id": "p358"
    }
  }, [_vm._v("Ash swallowed. Had this dour old man actually made a joke?")]), _c('p', {
    attrs: {
      "id": "p359"
    }
  }, [_vm._v("He followed Fred to the house and stood awkwardly in the kitchen. Minutes later Fred returned, holding out a check.")]), _c('p', {
    attrs: {
      "id": "p360"
    }
  }, [_vm._v("The old man was smiling. “I wish I could be a fly on the wall at the bank tomorrow when the Colliers, father and son, see this. The stingy bastards.”")]), _c('p', {
    attrs: {
      "id": "p361"
    }
  }, [_vm._v("Ash’s smile came slowly, before it bloomed on his lips, in his eyes. He accepted the check and shook Fred Covington’s work-worn hand. “I’ll never forget this, Fred. I…I was prepared to let it all go and start again.”")]), _c('p', {
    attrs: {
      "id": "p362"
    }
  }, [_vm._v("“That’s what I like about you, son. You remind me of myself at your age.” His voice lowered. “I started over a number of times before it all began working for me. But once it did, I never took it for granted. I appreciated everything I had. And still do, truth be told.”")]), _c('p', {
    attrs: {
      "id": "p363"
    }
  }, [_vm._v("Ash studied the old man with new respect. “How many times did you have to start over before you got it right?”")]), _c('p', {
    attrs: {
      "id": "p364"
    }
  }, [_vm._v("“Half a dozen, at least. But I tell you what, son. If it weren’t for the love of my good woman, I’d still be trying to figure things out.” He looked at Ash with those dark, piercing eyes. “You listen to me. If you find yourself a good woman, you make damned sure you never let her get away.”")]), _c('p', {
    attrs: {
      "id": "p365"
    }
  }, [_vm._v("“I’ll remember. Thanks, Fred.”")]), _c('p', {
    attrs: {
      "id": "p366"
    }
  }, [_vm._v("Clutching the check, Ash shook the old man’s hand again before turning toward his ranch in the distance.")]), _c('p', {
    attrs: {
      "id": "p367"
    }
  }, [_vm._v("As he made his way across the fields, his smile grew.")]), _c('p', {
    attrs: {
      "id": "p368"
    }
  }, [_vm._v("Thanks to the kindness of a neighbor he barely knew, he’d saved his ranch for at least a while longer.")]), _c('p', {
    attrs: {
      "id": "p369"
    }
  }, [_vm._v("He hadn’t admitted to Fred that he’d already betrayed the trust of the only good woman he’d ever known. Finding another like Brenna Crane wasn’t likely. And meeting any woman would have to take a back seat to ranch chores, at least for the foreseeable future. He intended to pay Fred back every penny before the year was up. If he had to work longer hours and tighten his belt even more, so be it. He intended to do whatever it took to make sure that Fred Covington never regretted putting his trust in him.")]), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line6"
    }
  }, [_c('p', {
    attrs: {
      "id": "p370"
    }
  })]), _c('p', {
    attrs: {
      "id": "p371"
    }
  }, [_vm._v("That was Ash’s last thought before he spied the shiny black car bearing a Montana license plate parked in front of his ranch house.")]), _c('p', {
    attrs: {
      "id": "p372"
    }
  }, [_vm._v("The man stepping out, dressed in a dark suit and tie and looking like the grim reaper, was no rancher. And the fact that he was from out of state meant that he wasn’t from the bank, either.")]), _c('p', {
    attrs: {
      "id": "p373"
    }
  }, [_vm._v("Whoever he was, and whatever brought him way out here, Ash figured he hadn’t come all this way bearing good news.")]), _c('p', {
    attrs: {
      "id": "p374"
    }
  }, [_vm._v("Ash stepped up onto his front porch and eyed the man.")]), _c('p', {
    attrs: {
      "id": "p375"
    }
  }, [_vm._v("“Ash MacKenzie?”")]), _c('p', {
    attrs: {
      "id": "p376"
    }
  }, [_vm._v("“Yeah.”")]), _c('p', {
    attrs: {
      "id": "p377"
    }
  }, [_vm._v("“Phil Bradley. I’ve been sent by Mason McMillan.”")]), _c('p', {
    attrs: {
      "id": "p378"
    }
  }, [_vm._v("“My father’s lawyer? You a private investigator?”")]), _c('p', {
    attrs: {
      "id": "p379"
    }
  }, [_vm._v("The man nodded. “Could we go inside?”")]), _c('p', {
    attrs: {
      "id": "p380"
    }
  }, [_vm._v("Ash made no move to open the door. “So my family resorted to hiring an investigator to find me. Now that you have, you can get off my property and hightail it back to Montana with the news that you were successful. I’m sure that’ll earn you a fat bonus.”")]), _c('p', {
    attrs: {
      "id": "p381"
    }
  }, [_vm._v("As he opened the front door and stepped inside, the man’s hand shot out, preventing Ash from closing it in his face.")]), _c('p', {
    attrs: {
      "id": "p382"
    }
  }, [_vm._v("Ash gave a sigh of disgust. “Okay. Why don’t you say what you came here to say and let me get back to work.”")]), _c('p', {
    attrs: {
      "id": "p383"
    }
  }, [_vm._v("“I’m sorry to tell you that your father is dead. He was…”")]), _c('p', {
    attrs: {
      "id": "p384"
    }
  }, [_vm._v("Ash never heard the rest. His hand lowered to his side and he stumbled inside like a drunk before dropping down heavily on a kitchen chair.")]), _c('p', {
    attrs: {
      "id": "p385"
    }
  }, [_vm._v("Phil Bradley followed him inside and watched as Ash struggled to clear his mind.")]), _c('p', {
    attrs: {
      "id": "p386"
    }
  }, [_vm._v("“My father…When? How?”")]), _c('p', {
    attrs: {
      "id": "p387"
    }
  }, [_vm._v("“Two days ago. Shot in the back by an unknown killer.”")]), _c('p', {
    attrs: {
      "id": "p388"
    }
  }, [_vm._v("“Murdered?” Ash couldn’t seem to wrap his mind around such stunning news.")]), _c('p', {
    attrs: {
      "id": "p389"
    }
  }, [_vm._v("“I had to do a lot of digging to find you. Your family didn’t want you to hear this by phone.”")]), _c('p', {
    attrs: {
      "id": "p390"
    }
  }, [_vm._v("“My family.” Ash closed his eyes on the pain. His mother, his brother, dealing with this for two days while he was wasting his time worrying about a piece of land.")]), _c('p', {
    attrs: {
      "id": "p391"
    }
  }, [_vm._v("“What should I tell them?”")]), _c('p', {
    attrs: {
      "id": "p392"
    }
  }, [_vm._v("“Tell them…? My family?” Ash’s head came up and he struggled to focus.")]), _c('p', {
    attrs: {
      "id": "p393"
    }
  }, [_vm._v("He would phone Fred Covington and make whatever arrangements he could on the spur of the moment. Nothing else mattered now except being with his family. “Tell them I’ll be there as soon as possible.”")]), _c('p', {
    attrs: {
      "id": "p394"
    }
  }, [_vm._v("Bradley nodded. “Your mother requested a phone number where she could reach you.”")]), _c('p', {
    attrs: {
      "id": "p395"
    }
  }, [_vm._v("Too stunned to speak, Ash held up his phone, displaying the number. The investigator punched the numbers into his own cell phone before letting himself out.")]), _c('p', {
    attrs: {
      "id": "p396"
    }
  }, [_vm._v("Ash lowered his face to his hands.")]), _c('p', {
    attrs: {
      "id": "p397"
    }
  }, [_vm._v("His father dead. Murdered. It was too much to process.")]), _c('p', {
    attrs: {
      "id": "p398"
    }
  }, [_vm._v("It couldn’t be true. It couldn’t. Bear MacKenzie was too tough, too ornery, to die.")]), _c('p', {
    attrs: {
      "id": "p399"
    }
  }, [_vm._v("Grief welled up, choking him. There was a terrible band around his heart, making it impossible to take a breath.")]), _c('p', {
    attrs: {
      "id": "p400"
    }
  }, [_vm._v("He roared up from his chair and stormed across the room, pounding a fist into the wall. Even the pain that shot up his arm wasn’t enough to overcome the terrible, black grief that had him by the throat, squeezing all the air from his lungs.")]), _c('p', {
    attrs: {
      "id": "p401"
    }
  }, [_vm._v("He’d worked so hard. Denied himself so much, just to be able to go home one day and prove to his father that he could make it all on his own. It had been the thought of seeing his father’s respect that had driven him like a man possessed.")]), _c('p', {
    attrs: {
      "id": "p402"
    }
  }, [_vm._v("And now, he could never stand before Bear MacKenzie and say the one thing he’d wanted to say more than anything in this world.")]), _c('p', {
    attrs: {
      "id": "p403"
    }
  }, [_vm._v("“Oh, Pop.” Anger and anguish and guilt rolled through him in a storm of emotions that dropped him to his knees. “Why did I let the MacKenzie curse take me this far? Why did we always resort to our fists? Why couldn’t one of us have said we were sorry?”")]), _c('p', {
    attrs: {
      "id": "p404"
    }
  }, [_vm._v("He got to his feet and began to pace. "), _c('i', [_vm._v("This is my fault. My fault. My fault. I deserted everyone I love because of this damnable temper. And though I’ve spent years blaming you, Pop, I’m the one who made the choice to go so far away from all the people I love.")])]), _c('p', {
    attrs: {
      "id": "p405"
    }
  }, [_c('i', [_vm._v("The people I love.")])]), _c('p', {
    attrs: {
      "id": "p406"
    }
  }, [_vm._v("Despite all the bitter battles of will, the shouting, the cursing, the angry words spoken in a haze of fury, he had loved his father. And knew in his heart that his father—though critical of everything he’d done, and ready to stand toe to toe with his oldest son every step of his journey to manhood—had loved him, too.")]), _c('p', {
    attrs: {
      "id": "p407"
    }
  }, [_vm._v("What had Mad always said? Bear just wanted his sons to be tough enough to survive this harsh land and the almost superhuman demands made on anyone who chose ranching for a lifetime.")]), _c('p', {
    attrs: {
      "id": "p408"
    }
  }, [_vm._v("“Oh Pop. What a waste. What a terrible waste of years ” With an arm across his eyes, Ash sank down on the ancient sofa that had been left by the ranch’s former owner.")]), _c('p', {
    attrs: {
      "id": "p409"
    }
  }, [_vm._v("Overcome with a blinding, bitter grief, he wept scalding tears over his loss.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "dateline2-rw",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "dateline4"
    }
  }, [_c('em', [_vm._v("Kabul, Afghanistan")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p410"
    }
  }, [_vm._v("“Hey, Griff. Got a cigarette?” Jimmy Gable had just celebrated his twenty-first birthday the previous week. When he’d entered the Corps at eighteen, he’d been a pudgy kid fresh out of school. Now, despite his babyish face, muscle replaced the fat, and there was a toughness in his demeanor that came from facing death in the hills of Afghanistan. He considered thirty-year-old Griff Warren his closest friend despite the difference in their ages and backgrounds. The two had bonded over long nights spent under the heavy cloak of darkness punctuated by bursts of enemy fire.")]), _c('p', {
    attrs: {
      "id": "p411"
    }
  }, [_vm._v("“Here.” Griff tossed aside the last of his cold coffee and handed over the pack after taking a cigarette for himself.")]), _c('p', {
    attrs: {
      "id": "p412"
    }
  }, [_vm._v("“Thanks. I thought you quit.” With a grin, Jimmy struck a light to his own, and then to Griff’s.")]), _c('p', {
    attrs: {
      "id": "p413"
    }
  }, [_vm._v("“I did. For about an hour.”")]), _c('p', {
    attrs: {
      "id": "p414"
    }
  }, [_vm._v("The two men stretched out their legs and inhaled deeply.")]), _c('p', {
    attrs: {
      "id": "p415"
    }
  }, [_vm._v("“You still thinking of doing another tour?” Jimmy blew out a stream of smoke.")]), _c('p', {
    attrs: {
      "id": "p416"
    }
  }, [_vm._v("“Yeah.” Griff did the same, watching the smoke dissipate into the night air. “Nothing else to do with my life now.”")]), _c('p', {
    attrs: {
      "id": "p417"
    }
  }, [_vm._v("“Tough about your mother.”")]), _c('p', {
    attrs: {
      "id": "p418"
    }
  }, [_vm._v("When Griff said nothing, Jimmy figured that the pain of loss was still too fresh. Griff’s plans for a grand reunion when he was discharged had all somehow gone up in smoke.")]), _c('p', {
    attrs: {
      "id": "p419"
    }
  }, [_vm._v("“Maybe I’ll stay in with you and do another tour.”")]), _c('p', {
    attrs: {
      "id": "p420"
    }
  }, [_vm._v("At Jimmy’s words, Griff looked at his young friend and shook his head. “There’s no future here for you.”")]), _c('p', {
    attrs: {
      "id": "p421"
    }
  }, [_vm._v("“And there is for you?”")]), _c('p', {
    attrs: {
      "id": "p422"
    }
  }, [_vm._v("Griff shrugged. “It’s different for me. I’ve got no future back home, either. I’ve got nobody. But you’ve got that big family just waiting to smother you with love.”")]), _c('p', {
    attrs: {
      "id": "p423"
    }
  }, [_vm._v("“Yeah. "), _c('i', [_vm._v("Smother")]), _vm._v(" being the operative word.” Jimmy gave a dry laugh. “With two older brothers and three sisters, I’ve been smothered from the day I was born. When I joined the Marines, I became plain old Jimmy Gable. Here, I’m not Artie’s little brother, or Audrey’s cute brother. Or John Gable’s kid.”\n         ")]), _c('p', {
    attrs: {
      "id": "p424"
    }
  }, [_vm._v("“You should be proud to be someone’s kid.”")]), _c('p', {
    attrs: {
      "id": "p425"
    }
  }, [_vm._v("At the rough tone of voice, Jimmy fell silent, embarrassed at that slip of the tongue. Though Griff kept his personal life pretty much to himself, he’d once said that he grew up without a father, or any family except his mother. To Jimmy, that sounded like heaven. But seeing the look in Griff’s eyes, he knew his friend considered it more like hell.")]), _c('p', {
    attrs: {
      "id": "p426"
    }
  }, [_vm._v("Over these past months Jimmy had begun to look up to Griff Warren as the epitome of a man and a Marine. Griff was strong, silent, and absolutely fearless. His muscled body was rock solid, his mind razor sharp. During their rare breaks away from combat, Jimmy had seen the way women looked at his friend. And no wonder. Even with that hint of danger in those dark eyes that warned everyone to keep their distance, Griff Warren was handsome in a rugged, dangerous sort of way. To Jimmy’s way of thinking, though, any woman who dared to take on Griff would have to be prepared to take on the devil himself. It wasn’t just the scar that ran from below his ear to his chest, a souvenir from a crazed enemy soldier. There was something dark and wounded that showed itself in those brief moments when Griff let down his guard. Something that spoke of a pain too deep for words. And maybe an anger that simmered and boiled deep inside. Jimmy just hoped he never caused that anger to boil over. It wouldn’t be pretty.")]), _c('p', {
    attrs: {
      "id": "p427"
    }
  }, [_vm._v("When the mail was distributed, Jimmy clutched half a dozen envelopes, taking his time opening each one and chuckling as he read the long, newsy letters from his family.")]), _c('p', {
    attrs: {
      "id": "p428"
    }
  }, [_vm._v("He was surprised to see Griff holding an envelope. “Hey. Look at you. You got some mail.”")]), _c('p', {
    attrs: {
      "id": "p429"
    }
  }, [_vm._v("“Yeah.” Griff studied the letterhead on the legal-size envelope before slitting it open.")]), _c('p', {
    attrs: {
      "id": "p430"
    }
  }, [_vm._v("He read through the official letter once, then read it again before carefully folding it and placing it back in the envelope.")]), _c('p', {
    attrs: {
      "id": "p431"
    }
  }, [_vm._v("He stood and tucked it into his breast pocket before saying casually, “I guess I’ll be taking that discharge after all.”")]), _c('p', {
    attrs: {
      "id": "p432"
    }
  }, [_vm._v("As he started away, Jimmy called, “You win the lottery?”")]), _c('p', {
    attrs: {
      "id": "p433"
    }
  }, [_vm._v("Griff paused and looked back. His eyes were dark and fathomless. Whatever he was feeling, it had been carefully banked.")]), _c('p', {
    attrs: {
      "id": "p434"
    }
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "dateline2-rw",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "dateline5"
    }
  }, [_c('em', [_vm._v("Copper Creek, Montana")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p435"
    }
  }, [_vm._v("When Whit MacKenzie volunteered to babysit the herd on the western ridge for the night, nobody gave it much thought. Whit was known by his family and by the wranglers of the MacKenzie Ranch as a loner. He was a cowboy through and through. Whit ate, slept, and dreamed about ways to make his father’s ranch bigger and more successful than any other in Montana. And because of his father’s constant criticism, he’d learned early in life to put as much distance as possible between himself and the man to whom he would never measure up.")]), _c('p', {
    attrs: {
      "id": "p436"
    }
  }, [_vm._v("The odd thing was, even though Whit had inherited the same hair-trigger temper that plagued all the MacKenzies, he’d also been blessed with a zany sense of humor. In fact, his friends often referred to him as “Whit the wit” in the MacKenzie family.")]), _c('p', {
    attrs: {
      "id": "p437"
    }
  }, [_vm._v("Whit often spent weeks, even months, up in the hills, without ever feeling the need for companionship. The wranglers knew him to be tough, independent, and a free spirit. He carried a stash of books in his saddlebags, and would often curl up on a cot in the bunkhouse and read while the wranglers were passing the nights playing poker. They loved having Whit along, because they all knew that he would willingly take on the late-night hours keeping watch over the herd so that he could be alone with his thoughts.")]), _c('p', {
    attrs: {
      "id": "p438"
    }
  }, [_vm._v("This night, as he and his horse patrolled the perimeter of the camp, he could hear the faint bursts of laughter or swearing from the bunkhouse.")]), _c('p', {
    attrs: {
      "id": "p439"
    }
  }, [_vm._v("His thoughts turned to all the crazy events of the past week. His father dead. Murdered. It didn’t seem real. He had the feeling that he’d ride back home in a few days and find his father seated at the table, talking and laughing with his mother and Mad, and explaining that it had all been a misunderstanding.")]), _c('p', {
    attrs: {
      "id": "p440"
    }
  }, [_vm._v("Then there was the fact that Ash had been contacted, and had sent word that he would be home as soon as he could make arrangements for someone to tend his ranch and herds in Wyoming. Though Whit still resented the fact that his big brother had abandoned him all those years ago, he couldn’t deny that he was eager to see him again. His heart beat faster just thinking about their reunion.")]), _c('p', {
    attrs: {
      "id": "p441"
    }
  }, [_vm._v("And then there was the bastard. Whit liked thinking about the stranger that way. A bastard. A sneaky thief in the night, hoping to cash in on the accident of his birth.")]), _c('p', {
    attrs: {
      "id": "p442"
    }
  }, [_vm._v("Mason McMillan had already received word that Griff Warren was planning on paying a call on the family as soon as his discharge from the Corps was finalized.")]), _c('p', {
    attrs: {
      "id": "p443"
    }
  }, [_vm._v("Well, Whit had news for Griff Warren. He was free to visit and pay his respects, but after that, he’d better be prepared to head back to wherever he came from.")]), _c('p', {
    attrs: {
      "id": "p444"
    }
  }, [_vm._v("Whit’s hand fisted the reins.")]), _c('p', {
    attrs: {
      "id": "p445"
    }
  }, [_vm._v("Griff Warren would learn soon enough that there was no room on the MacKenzie Ranch for someone pretending to be one of them.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a0e000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s007-Chapter-004.vue
// module id = 78
// module chunks = 0